export const isProduction = process.env.REACT_APP_ENV_NAME === 'prod';
export const isStaging = process.env.REACT_APP_ENV_NAME === 'staging';
export const isQA = process.env.REACT_APP_ENV_NAME === 'qa';
export const isLocal = process.env.REACT_APP_ENV_NAME === 'local';
export const enableDebug = !isProduction && !isStaging
